import { useEffect, useState } from "react";
import styles from "./HowToPlay.module.css";

function HowToPlay({ props, closeModal }) {
    const elements = props.elements;
    const [index, setIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);

    // Обрабатываем свайп жесты
    const handleTouchStart = (e) => {
        setTouchStartX(e.changedTouches[0].screenX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.changedTouches[0].screenX);
    };

    const handleTouchEnd = () => {
        if (touchStartX - touchEndX > 50) {
            // Свайп влево
            nextElement();
        }

        if (touchEndX - touchStartX > 50) {
            // Свайп вправо
            previousElement();
        }
    };

    const previousElement = () => {
        if ((index - 1) >= 0) {
            setIndex(index - 1);
        }
    };

    const nextElement = () => {
        if ((index + 1) >= elements.length) {
            closeModal();
        }
        if ((index + 1) < elements.length) {
            setIndex(index + 1);
        }
    };



    return (
        <div className={styles.wrapper}>
            <div className={styles.containerInfo}>
                <div className={styles.wrapperButton}>
                    <div className={styles.buttonChoice} onClick={previousElement}>
                        <i className="fa-solid fa-arrow-left"></i>
                    </div>
                </div>
                <div className={styles.infoBlock} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                    {elements[index]}
                </div>
                <div className={styles.wrapperButton}>
                    <div className={styles.buttonChoice} onClick={nextElement}>
                        <i className="fa-solid fa-arrow-right"></i>
                    </div>
                </div>
            </div>
            <div className={styles.containerCircles}>
                {elements.map((value, index_circle) => <div className={styles.circle} onClick={()=>setIndex(index_circle)} style={{border:index===index_circle?"2px solid rgb(47, 62, 87)":"none"}}>
                    <div className={styles.circleMini}></div>
                </div>)


                }

            </div>

        </div>

    );
}

export default HowToPlay;
